import axios from "axios";
import { getEnvVariables } from "../helpers/getEnvVariables";

const { VERIFICATION_SURVEY, SURVEY } = getEnvVariables();

const axiosBaseSurvey = axios.create({
    baseURL: `${VERIFICATION_SURVEY}/${SURVEY}`,
    headers: { "Content-Type": "application/json" },
});

export default axiosBaseSurvey;
